import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { isString } from 'lodash';
import { ContentContainer } from 'components/ContentContainer';
import { Heading } from 'components/Typography';
import { Button } from 'components/Button';
import { ButtonLink } from 'components/ButtonLink';

type Props = {
  className?: string;
};

export const FixedBanner: React.FC<Props> = ({ children, className }) => {
  return (
    <ContentContainer variant="full" className="fixed z-20 bottom-0 left-0">
      <div
        className={twMerge(
          cx(
            'flex items-center justify-between gap-24',
            'bg-yellow-300 shadow-md ',
            'p-24 lg-d:flex-col lg-d:items-start',
            'rounded-lg',
          ),
          className,
        )}
      >
        {children}
      </div>
    </ContentContainer>
  );
};

type CtaBannerProps = {
  buttonText: string;

  onClickCTA?: () => void;
  to?: string;

  className?: string;
};
export const FixedCtaBanner: React.FC<CtaBannerProps> = ({ onClickCTA, to, children, buttonText, className }) => {
  const ButtonComponent = isString(to) ? ButtonLink : Button;

  return (
    <FixedBanner className={className}>
      <Heading level="h5">{children}</Heading>
      <ButtonComponent
        variant="primary"
        size="lg"
        onClick={onClickCTA}
        to={to as string}
        className="shrink-0 sm-d:w-full"
      >
        {buttonText}
      </ButtonComponent>
    </FixedBanner>
  );
};
